// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const JsonResponse = {
    response: (value) => {
        return Object.assign(Object.assign({}, value), { type: "response", _visit: function (visitor) {
                return FernIr.JsonResponse._visit(this, visitor);
            } });
    },
    nestedPropertyAsResponse: (value) => {
        return Object.assign(Object.assign({}, value), { type: "nestedPropertyAsResponse", _visit: function (visitor) {
                return FernIr.JsonResponse._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "response":
                return visitor.response(value);
            case "nestedPropertyAsResponse":
                return visitor.nestedPropertyAsResponse(value);
            default:
                return visitor._other(value);
        }
    },
};
